import { BaseControl } from './base-control.model';
import { BaseControlOption, ReadOnlyProperty } from '../control-options/control-option.interface';

export class UiControl<T> extends BaseControl {

  value: T | null;
  originalValue: T | null;
  postAsArray: boolean = false;

  constructor(id: string, label: string, selectedValue: T, postAsArray: boolean, ...options: BaseControlOption[]) {
    super(id, label, options);
    this.postAsArray = postAsArray;
    this.value = selectedValue;
    this.originalValue = selectedValue;
  }

  addOption(option: BaseControlOption): void {
    var name = option.constructor.name;

    if (this.options === undefined) {
      this.options = [];
    }

    var o = this.options.filter(v => v.constructor.name === name)[0];
    if (o === undefined || o === null) {
      this.options.push(option);
    }
  }

}
